<template>
  <div class="kind-part">
    <div class="w-100">
      <div class="header">
        <span class="block-title">{{ kindSelectTitle }}</span>
        <functionButtons
          v-if="!noKindFuncBtns"
          :hasAdd="true"
          :hasEdit="true"
          :hasRemove="true"
          :hasSequence="true"
          @onAdd="addKind"
          @onEdit="editKind"
          @onRemove="removeKind"
          @onSequence="sequenceKind"
        ></functionButtons>
      </div>
      <div>
        <select
          id="comboKindList"
          v-model="currentKindId"
          @change="changeKindId"
        >
          <option
            v-for="kind in kinds"
            :key="kind[idProperty]"
            :value="kind[idProperty]"
          >
            {{ kind[nameProperty] }}
          </option>
        </select>
      </div>
    </div>
    <div class="kind-part-table-container">
      <dataBodyPart
        :tableTitle="kindTitle"
        :columns="columns"
        :items="items"
        :viewName="viewName"
        :noColumnPropertySetting="true"
        :noHide="true"
        :hasPage="false"
        @currentIndexChanged="currentIndexChanged"
      >
        <template #functionButtons>
          <functionButtons
            :hasAdd="true"
            :hasEdit="hasEdit"
            :hasRemove="hasRemove"
            :hasSequence="hasSequence"
            @onAdd="addApplyKind"
            @onEdit="editApplyKind"
            @onRemove="removeApplyKind"
            @onSequence="sequenceApplyKind"
          ></functionButtons>
        </template>
        <template #th-after>
          <slot name="th-after">
            <th class="th-select" style="width: auto">
              <div style="min-width: 50px"></div>
            </th>
          </slot>
        </template>
        <template #td-after="props">
          <slot name="td-after" :item="props.item">
            <td style="width: auto"></td></slot
        ></template>
      </dataBodyPart>
    </div>
  </div>
</template>

<script>
import functionButtons from "@/components/tools/FunctionButtons.vue";
import dataBodyPart from "@/components/parts/dataBodyPart.vue";
export default {
  data() {
    return {
      currentKindId: null,
      isFirstTime: true,
    };
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    kinds: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    kindSelectTitle: {
      type: String,
      default: "類別",
    },
    kindTitle: {
      type: String,
      default: "套用項目",
    },
    viewName: String,
    idProperty: String,
    nameProperty: String,
    hasEdit: Boolean,
    hasRemove: Boolean,
    hasSequence: Boolean,
    noKindFuncBtns: Boolean,
  },
  emits: [
    "currentIndexChanged",
    "changeKindId",
    "addKind",
    "editKind",
    "removeKind",
    "sequenceKind",
    "removeItem",
    "sequenceItem",
    "addApplyKind",
    "editApplyKind",
    "removeApplyKind",
    "sequenceApplyKind",
  ],
  components: {
    functionButtons,
    dataBodyPart,
  },
  watch: {
    kinds(newValue, oldValue) {
      if (newValue.length > 0) {
        if (newValue.length > oldValue.length && !this.isFirstTime) {
          this.currentKindId = newValue[newValue.length - 1][this.idProperty];
        } else {
          this.currentKindId = newValue[0][this.idProperty];
        }
        this.isFirstTime = false;
      }
    },
    currentKindId() {
      this.changeKindId();
    },
  },
  methods: {
    changeKindId() {
      this.$emit("changeKindId", this.currentKindId);
    },
    currentIndexChanged(index) {
      this.$emit("currentIndexChanged", index);
    },
    trClick() {},
    addKind() {
      this.$emit("addKind");
    },
    editKind() {
      this.$emit("editKind");
    },
    removeKind() {
      this.$emit("removeKind");
    },
    sequenceKind() {
      this.$emit("sequenceKind");
    },
    addApplyKind() {
      this.$emit("addApplyKind");
    },
    editApplyKind() {
      this.$emit("editApplyKind");
    },
    removeApplyKind() {
      this.$emit("removeApplyKind");
    },
    sequenceApplyKind() {
      this.$emit("sequenceApplyKind");
    },
  },
};
</script>

<style lang="scss" scoped>
.kind-part {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 38%;
  min-width: 320px;
  height: 100%;
  max-height: calc(100vh - 48px);
  padding-right: 24px;
  padding-bottom: 20px;
  @media screen and (max-width: 767px) {
    width: 100%;
    height: auto;
    padding-right: 0;
    padding-bottom: 0;
  }
}
.kind-part-table-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  flex-grow: 1;
}
</style>
